module.exports = __webpack_public_path__ + "static/img/colobus-plaza.542cde0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/colobus-plaza.jpg
// module id = 630
// module chunks = 0